import { Component, inject } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SearchComponent } from "src/app-legacy/layout/topbar/search/search.component";

@Component({
	selector: "app-topbar-search",
	imports: [MatIcon],
	templateUrl: "./topbar-search.component.html",
})
export class TopbarSearchComponent {
	private modal = inject(NgbModal);

	openSearchModal(): void {
		this.modal.open(SearchComponent);
	}
}
